jQuery( document ).ready( function ( $ ) {
	if( $(".block-success-stories-horizontal" ).length ) {
		let $caseStudiesSlides = $('.block-mp-horizontal-icon-slider .horizontal-slider-list');
		const caseStudySlider = initCustonSliderNav(
			$('.block-success-stories-horizontal .case-studies-slider'),
			$('.block-success-stories-horizontal .slider-nav-dots'),
			{
				dots: true,
				arrows: true,
				infinite: false,
				speed: 500,
				slidesToShow: 1,
				slidesToScroll: 1,
				touchMove: true,
				mobileFirst: true,
				accessibility: true,
				draggable: true,
				adaptiveHeight:true,
				responsive: [
					{
						breakpoint: 860,
						settings: {
							slidesToShow: 2.1,
							slidesToScroll: 1,
							arrows: true,
							dots: true,
							prevArrow: $('.slick-prev-horizontal'),
							nextArrow: $('.slick-next-horizontal'),
						}
					},
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 2.5,
							slidesToScroll: 1,
							arrows: true,
							dots: true,
							prevArrow: $('.slick-prev-horizontal'),
							nextArrow: $('.slick-next-horizontal'),
						}
					},
					{
						breakpoint: 1700,
						settings: {
							slidesToShow: 2.7,
							slidesToScroll: 1,
							arrows: true,
							dots: true,
							prevArrow: $('.slick-prev-horizontal'),
							nextArrow: $('.slick-next-horizontal'),
						}
					},
				]
			}
		);

		document.addEventListener("visibilitychange", function() {
			if (document.hidden) {
				$caseStudiesSlides.slick('slickPause');
			} else {
				$caseStudiesSlides.slick('slickPlay');
			}
		});


		$(window).on('resize orientationchange', function() {
			$caseStudiesSlides.slick('slickPlay');
		});
	}
})